export const PASSENGERS_TRANSLATE_KEY = 'PASSENGERS';
export const GUESTS_TRANSLATE_KEY = 'GUESTS';
export const DRIVERS_TRANSLATE_KEY = 'DRIVERS';
export const TRAVELER_TRANSLATE_KEY = 'TRAVELER';
export const TRAVELERS_TRANSLATE_KEY = 'TRAVELERS';
